export default "__VITE_ASSET__Bjh0aJRh__"